import * as React from 'react';

export default class Airbnb extends React.Component<{}, {}> {
  public render() {
    return <p>Airbnb instructions</p>;
  }
}



// WEBPACK FOOTER //
// ./src/pages/IntegrationInstructions/private/Airbnb.tsx